var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#3d6472",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 436.24 436.239",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M396.64,211.551c-12.75,0-23.084,10.336-23.084,23.084c0,85.708-69.73,155.437-155.439,155.437 c-85.709,0-155.437-69.729-155.437-155.437S132.41,79.197,218.118,79.197c5.504,0,10.98,0.293,16.411,0.862l-13.607,24.446 c-1.604,2.883-1.549,6.401,0.146,9.232c1.668,2.789,4.678,4.492,7.922,4.492c0.049,0,0.098,0,0.146-0.002l114.146-1.792 c3.299-0.053,6.318-1.859,7.924-4.741c1.604-2.883,1.549-6.402-0.145-9.233L292.443,4.493c-1.695-2.83-4.756-4.563-8.068-4.491 c-3.299,0.052-6.318,1.859-7.924,4.742l-17.996,32.332c-13.217-2.685-26.713-4.049-40.335-4.049 c-53.851,0-104.479,20.971-142.557,59.049c-38.078,38.078-59.049,88.706-59.049,142.558c0,53.851,20.971,104.479,59.049,142.557 c38.078,38.078,88.705,59.049,142.556,59.049c53.85,0,104.479-20.971,142.557-59.049s59.051-88.706,59.051-142.558 C419.724,221.887,409.388,211.551,396.64,211.551z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.91,333.346c-2.557-6.568-4.311-10.745-4.311-10.745c-2.309-5.521-7.861-9.056-13.162-11.229l-35.835-16.498 l-17.214-14.518l-27.662,27.513l9.98,66.722C264.082,371.768,294.988,356.517,317.91,333.346z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.8,311.37c-5.302,2.175-11.07,5.95-13.162,11.229c0,0-1.754,4.178-4.311,10.745 c22.922,23.171,53.828,38.423,88.203,41.243l9.979-66.722l-27.661-27.513l-17.214,14.518L135.8,311.37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.738,188.425c0.396-39.734-18.527-63.515-64.621-63.515c-46.094,0-65.021,23.779-64.618,63.515 c0.622,57.262,27.969,91.406,64.618,91.406C254.765,279.831,282.115,245.686,282.738,188.425z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerStatus);
export default __webpack_public_path__ + "static/media/customer-status.9fcdb5e54c104a8a1c0caf9e89d98211.svg";
export { ForwardRef as ReactComponent };